import { useState } from "react";
import { today } from "../constants/categories";

export function useHistoryState() {
  const [history, setHistory] = useState([]);
  const [calMonth, setCalMonth] = useState(today.getMonth());
  const [calYear, setCalYear] = useState(today.getFullYear());
  const [selectedDay, setSelectedDay] = useState(null);
  const [historyStyle, setHistoryStyle] = useState("duolingo");

  return {
    history, setHistory,
    calMonth, setCalMonth, calYear, setCalYear,
    selectedDay, setSelectedDay,
    historyStyle, setHistoryStyle,
  };
}
